import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleQuotation } from '../../../Store/PHPSlice/Sale/Quotation';
import PrintIcon from '@mui/icons-material/Print';
import PreviewIcon from '@mui/icons-material/Preview';
import DescriptionIcon from '@mui/icons-material/Description';
import EditIcon from '@mui/icons-material/Edit';
import QueryStatsIcon from '@mui/icons-material/QueryStats';

const TableBody = ({
    serialNumber,
    id,
    qtMemo,
    qtMemos,
    dt,
    partyNm,
    firmNm,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();

    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this Quotation?");

        // If user confirms, proceed with deletion
        // if (isConfirmed) {
        //     dispatch(deleteSingleQuotation(id))
        //         .then(() => {
        //             // Reload the page to show updated results
        //             toast.success("Quotation Deleted Sucessfully");
        //             window.location.reload();
        //         })
        //         .catch((error) => {
        //             // Handle any errors that occur during the deletion process
        //             console.error("Error deleting Item:", error);
        //             toast.error("Failed to delete Item");
        //         });
        // }
    };

    const handleViewClick = () => {
        window.open(`/multi-quotation-view/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDiscountView=()=>{
             window.open(`/qtDiscountPer/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
   
    }

    const handleSCRView = () => {
        window.open(`/multiple-quotation-scr/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const handleMILView = () => {
        window.open(`/multiple-quotation-mil/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };


    const handleRetailerView = () => {
        window.open(`/multiple-quotation-retailer/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };


    const handleMRPView = () => {
        window.open(`/multiple-quotation-mrp/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };


    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {serialNumber}
                </TableCell>
                {/* scr */}
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PrintIcon onClick={handleSCRView} className='cursor-pointer' />
                </TableCell>
                {/* mil */}
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PrintIcon onClick={handleMILView} className='cursor-pointer' />
                </TableCell>
                {/* retailer */}
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PrintIcon onClick={handleRetailerView} className='cursor-pointer' />
                </TableCell>
                {/* mrp */}
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PrintIcon onClick={handleMRPView} className='cursor-pointer' />
                </TableCell>
                  <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <EditIcon onClick={handleDiscountView} className='cursor-pointer' />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>
                   {/* <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {qtMemos}
                </TableCell> */}
                <TableCell
  sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }}
  align="center"
>
  {qtMemos &&
    qtMemos.split(', ').map((item, index) => {
      const match = item.match(/(.*)\((\d)\)/);
      if (!match) return item;

      const quotNo = match[1];
      const status = match[2];

      return (
        <span
          key={index}
          style={{
            color: status === '1' ? 'red' : 'black',
            fontWeight: status === '1' ? 'bold' : 'normal',
            marginRight: '6px'
          }}
        >
          {quotNo}
          {index !== qtMemos.split(', ').length - 1 && ', '}
        </span>
      );
    })}
</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {qtMemo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {firmNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {partyNm}
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} />
                </TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
